<template>
  <div id="bundles">
    <div class="content" style="padding: 110px 0 0 0" >
      <div  class="top-nav filter-blur-50 border-bottom-white-1-50" v-if="fetched && !error" :class="[this.$lang === 'ar' ? 'arabicTabs' : '']">
        <div style="width: 100vw" class="tabsContainer" >
          <v-tabs
            v-model="tab"
            grow
            centered
            show-arrows
            class="nav-tab"
          >
            <v-tabs-slider color="#FFCB05" ></v-tabs-slider>
            <v-tab v-for="(item, i) in bundles.items" :key="i" :class="[lang === 'ar' ? 'arabicTabs' : '']">
              <span :class="lang === 'ar' ? 'regular-ar' : 'regular-en'">{{ item.text }}</span>
            </v-tab>
          </v-tabs>
        </div>
      </div>
      <div  :class="[this.$lang === 'ar' ? '' : '', 'bottom-nav filter-blur-50 border-bottom-white-1-50']" v-show="fetched && !error">
        <div :class="[this.$lang === 'ar' ? 'flex-row' : '', 'nameContainer']">
          <div class="homeIcon" @click="$router.push('/')">
            <img src="../../assets/icons/homeIcon.svg" height="20px" width="20px">
          </div>
          <div :class="[this.$lang === 'ar' ? 'rotation' : '','arrowIcon']">
            <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
          </div>
          <div :class="[this.$lang === 'ar' ? 'flex-row-reverse bold-ar' : 'bold-en', 'titleName']">
            <span :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'd-flex secondary-titles']">
              <span  @click="$router.push('/products')">{{$t('segmentedProducts.mainTitle')}}</span>
            <div :class="[this.$lang === 'ar' ? 'rotation' : '','arrowIcon']">
              <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
            </div>
            <span @click="$router.push('/products/segment-products')">{{$t('segmentedProducts.secondaryTitle')}}</span>
            <div :class="[this.$lang === 'ar' ? 'rotation' : '','arrowIcon']">
              <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
            </div>
            </span>
            <span :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en', 'active']">{{sectionName}}</span>
          </div>
        </div>
        <div :class="[this.$lang === 'ar' ? '' : '', 'checkContainer']" >
          <form :class="[this.$lang === 'ar' ? '' : '', 'filterForm']" v-if="this.$store.state.selectedNumber === null">
            <div class="checkName">{{$t('popularBundles.showResults')}}</div>
            <div class="check">
              <input type="radio" id="pre" name="filter" value="0" @change="filter(0)" @click="arabicRadio" checked>
              <label for="pre" class="radioLabel pre">{{$t('popularBundles.PrePaid')}}</label>
            </div>
            <div class="check">
              <input type="radio" id="post" name="filter" value="1" @change="filter(1)" @click="arabicRadio">
              <label for="post" class="radioLabel post">{{$t('popularBundles.PostPaid')}}</label>
            </div>
          </form>
        </div>
      </div>
      <div :class="[!fetched ? 'd-flex align-items-center justify-center' : 'padding-100', 'inner-content']">
        <Error v-if="error" />
        <Loader v-if="!fetched && !error" style="padding: 5rem 0" />
        <div v-if="fetched && !error">
          <v-tabs-items :key="key"  v-model="tab" :touchless="true">
            <v-tab-item v-for="(item, i) in bundles.items" :key="i">
              <div class="segments gray-gradient-bottom0">
                <div v-if="item.types.length === 0">No data</div>
                <component id="bundle" :is="comp" v-for="(com, j) in item.types" :key="j" :obj="segmentCategoryRepo" :lineType="lineType" sliderHolder="segment" method="getSegmentCategory" :data="item.data[com]" :class="j % 2 === 0 ? 'back-en' : 'back-ar'" />
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SliderSection from '../../components/sections/SliderSection'
import $ from 'jquery'
import utils from '../../shared/utils'
import SegmentCategories from '../../repositories/SegmentCategoriesTow'
import Error from '../../components/errorHandle/Error'
import Loader from '../../components/LoaderBtn/Loader'
export default {
  name: 'Bundles',
  components: { SliderSection, Loader, Error },
  data () {
    return {
      lang: this.$lang,
      activeId: null,
      segmentCategoryRepo: new SegmentCategories(this.$route.params.id),
      comp: 'SliderSection',
      tab: { },
      bundles: {
        title: 'Bundles',
        items: []
      },
      tabsId: [],
      visitedTabs: [],
      lineType: 0,
      categories: '',
      fetched: false,
      error: false,
      size: 5,
      key: 0,
      previousTab: -1,
      sectionName: ''
    }
  },
  watch: {
    async tab (val, oldVal) {
      this.$store.state.searchValue = ''
      if (val === -1) {
        return
      }
      this.previousTab = val
      if (val === 1) {
        this.$lang === 'ar' ? $('svg.w-6.h-6.vue-simple-select-icon').css({ 'margin-left': 0, 'margin-right': 'auto' }) : $('svg.w-6.h-6.vue-simple-select-icon').css({ 'margin-left': 'auto', 'margin-right': 0 })
      }
      this.handleTab(val)
    },
    lineType (val) {
      this.handleLineType(val)
    }
  },
  created () {
    this.activeId = this.$route.params.id
    this.$store.state.activeSectionNav = 1
    this.$watch(() => {
      return this.$route.params.id
    }, (val) => {
      this.activeId = val
      this.tab = utils.checkActiveTabViaId(this.bundles.items, Number(this.activeId))
    })
    this.$watch(() => {
      return this.$store.state.searchValue
    }, (val) => {
      this.$forceUpdate()
      this.key++
    })
    this.getBundles(0)
  },
  mounted () {
    this.$store.state.showSearch = true
    this.arabic()
    this.$watch(() => {
      return this.$store.state.selectedNumber
    }, (val) => {
      this.$router.push('/products/segment-products')
    })
  },
  destroyed () {
    this.$store.state.showSearch = false
    this.$store.state.searchValue = ''
  },
  methods: {
    handleLineType (val) {
      // this.visitedTabs = []
      // this.tab = -1
      // this.tabsId = []
      // this.bundles.items = []
      // this.categories = {}
      // this.fetched = false
      // this.error = false
      // this.getBundles(val)
      // for (let i = 0; i < this.bundles.items.length; i++) {
      //   this.bundles.items[i].data.lineType = val
      // }
      this.$store.state.searchValue = ''
      this.$forceUpdate()
      this.key++
    },
    handleTab (val) {
      if (!this.visitedTabs.includes(val)) {
        for (let k = 0; k < this.bundles.items[val].types.length; k++) {
        }
      }
      this.visitedTabs.push(val)
    },
    filter (val) {
      this.lineType = val
    },
    async getBundles (line) {
      try {
        const response = await this.segmentCategoryRepo.get(this.$route.params.id, line)
        if (response.status === 200) {
          this.sectionName = response.data.segmentTitle
          this.categories = response
          this.bundles.items = []
          for (let i = 0; i < response.data.categories.length; i++) {
            this.bundles.items.push(
              {
                text: response.data.categories[i].title,
                id: response.data.categories[i].id,
                types: response.data.categories[i].types,
                data: []
              })
            this.tabsId.push(response.data.categories[i].id)
            for (let j = 0; j < this.bundles.items[i].types.length; j++) {
              this.bundles.items[i].data[this.bundles.items[i].types[j]] = {
                id: response.data.categories[i].id,
                durationType: this.bundles.items[i].types[j],
                sliderType: 'segment',
                lineType: this.lineType,
                main: { sectionId: 'popular_bundles', cardType: 'bundle', title: this.$t('dailyBundles.title'), description: this.$t('dailyBundles.desc'), image: '' },
                slider: []
              }
              if (this.bundles.items[i].types[j] === '1') {
                this.bundles.items[i].data[this.bundles.items[i].types[j]].main.title = this.$t('weeklyBundles.title')
                this.bundles.items[i].data[this.bundles.items[i].types[j]].main.description = this.$t('weeklyBundles.desc')
              } else if (this.bundles.items[i].types[j] === '2') {
                this.bundles.items[i].data[this.bundles.items[i].types[j]].main.title = this.$t('monthlyBundles.title')
                this.bundles.items[i].data[this.bundles.items[i].types[j]].main.description = this.$t('monthlyBundles.desc')
              }
            }
          }
          // if (this.$route.params.id !== undefined) {
          //   this.tab = utils.checkActiveTabViaId(this.bundles.items, Number(this.activeId))
          // } else {
          //   this.activeId = this.tabsId[0]
          // }
          this.fetched = true
        } else {
          this.fetched = false
          this.error = true
        }
      } catch (e) {
        console.log(e)
        this.fetched = false
        this.error = true
      } finally {
        // if (status) {
        //   this.$forceUpdate()
        //   this.key++
        // }
      }
    },
    arabicRadio () {
      if (this.$lang === 'ar') {
        $('.post').css('font-family', 'Mtn-arabic-regular')
        $('.pre').css('font-family', 'Mtn-arabic-regular')
        $('.post').css('font-size', '10px')
        $('.pre').css('font-size', '10px')
        if ($('#pre').is(':checked')) {
          $('.pre').css('font-family', 'Mtn-arabic-bold')
          $('.pre').css('font-size', '10px')
          // $('.post').css('font-family', 'Mtn-arabic-regular')
          // $('.post').css('font-size', '11px')
        } else if ($('#post').is(':checked')) {
          $('.post').css('font-family', 'Mtn-arabic-bold')
          $('.post').css('font-size', '10px')
          // $('.pre').css('font-family', 'Mtn-arabic-regular')
          // $('.pre').css('font-size', '11px')
        }
      }
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('.top-nav').css('direction', 'rtl')
        $('.bottom-nav').css('direction', 'rtl')
        $('.checkName').css('font-family', 'Mtn-arabic-bold')
        $('.arrowIcon').css('transform', 'rotateY(180deg)')
        $('.tabsContainer').addClass('arabicTabContainer')
        $('.nav-tab .v-tab').css('transform', 'rotateY(180deg)')
        // $('.radioLabel').css('font-size', '10px')
        $('.radioLabel').css('font-family', 'Mtn-regular')
        $('.titleName').css('direction', 'ltr')
      } else {
        // $('.titleName').css('direction', 'rtl')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
@import "src/assets/sass/modules/tabs";
@import "src/assets/sass/modules/extraNav";
.back-en{
  background: url("../../assets/images/circles-back-en.png") no-repeat;
}
.back-ar{
  background: url("../../assets/images/circles-back-ar.png") rgba(242, 242, 242, 0.5) no-repeat right;
}
.rotation{
  transform: rotate(180deg);
}
.inner-content{
  //padding: 5rem;
  min-height: calc(100vh - 395px);
}
.padding-100 {
  padding-top: 100px;
}
.padding-50 {
  padding-top: 50px;
}
.bundles-min {
  min-height: calc(100vh - 495px);
}
.gray-gradient-bottom0 {
  background-image: linear-gradient(to bottom, #F2F2F2, #e1e1e1);
  -moz-background-image: -moz-linear-gradient(to bottom, #F2F2F2, rgba(242, 242, 242, 1));
  -o-background-image: -o-linear-gradient(to bottom, #F2F2F2, rgba(242, 242, 242, 1));
  -webkit-background-image: -webkit-linear-gradient(to bottom, #F2F2F2, rgba(242, 242, 242, 1));
}

.section-title{
  border-bottom: 2px solid #ffffff;
  margin: 0 2vw;
  position: relative;
  padding: 15px 0;
}
.text-title{
  font-size: 28px;
  color: $--yellow;
}
.arrow {
  width: max-content;
  position: absolute;
  top: calc(50% - 9px);
  cursor: pointer;
}
.titleName span {
  cursor: pointer;
}
.homeIcon {
  cursor: pointer;
}
.homeIcon,
.arrowIcon,
.titleName{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1vw;
}
.titleName{
  width: max-content;
  color: black;
  font-family: Mtn-bold;
  font-size: 12px;
  text-decoration: none
}
.active{
  color: $--yellow;
  text-decoration: underline;
  cursor: default !important;
}
.arabicTabContainer{
  direction: ltr;
  transform: rotateY(180deg);
}
.filterForm{
  display: flex;
}
.checkContainer{
  font-size: 12px;
}
@media screen and (max-width: 650px) {
  .checkName {
    display: none;
  }
  .homeIcon,
  .arrowIcon{
    display: none;
  }
}
.arabicTabs{
  transform: rotateY(180deg) !important;
  font-family: Mtn-arabic-regular;
}
@media (max-width: 1000px) {
  .secondary-titles{
    display: none !important;
  }
  .text-title{
    font-size: 24px;
  }
}
</style>
<style>
.theme--light.v-tabs > .v-tabs-bar{
  background-color: transparent !important;
}
.v-tab{
  text-transform: capitalize;
}
</style>
